(function() {

    $(document).ready(function() {
        if (document.querySelector('.vss')) {
            let trackedTiles = new Set();

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            };

            const tileCallback = window.c24Lp.createIntersectionCallback(
                trackedTiles,
                [
                    'prefix',
                    'position',
                    'ppset',
                    'type',
                ],
                'tile:show',
                window.c24Lp.getMatomoEventCategory(),
            );

            const tileObserver = new IntersectionObserver(tileCallback, options);
            const tileTargets = document.querySelectorAll('.c24m-tile');
            tileTargets.forEach((tile) => {
                tileObserver.observe(tile);
            });

            let trackedChips = new Set();

            const chipCallback = window.c24Lp.createIntersectionCallback(
                trackedChips,
                [
                    'prefix',
                    'position',
                    'wpset',
                    'type',
                ],
                'xppset-chips:show',
                window.c24Lp.getMatomoEventCategory(),
            );

            const chipObserver = new IntersectionObserver(chipCallback, {
                ...options,
                threshold: 0.4,
            });
            const chipTargets = document.querySelectorAll('.c24m-chip');
            chipTargets.forEach((chip) => {
                chipObserver.observe(chip);
            });

            let productItemTracked = false;

            const productOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            };

            const productCallback = (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !productItemTracked) {
                        window._paq.push([
                            'trackEvent',
                            window.c24Lp.getMatomoEventCategory(),
                            'insurance-list:view',
                        ]);
                        productItemTracked = true;
                    }
                });
            };

            const productObserver = new IntersectionObserver(productCallback, productOptions);
            const productItem = document.querySelector('.productItem');
            productObserver.observe(productItem);

            window.c24Lp.createClickTracking('.mod24ComparisonBoxModern a', ['prefix', 'link'], 'insurance-list');

            window.c24Lp.createClickTracking('.c24m-chip', [
                'prefix',
                'position',
                'wpset',
                'type',
            ], 'xppset-chips');

            window.c24Lp.createClickTracking('.c24m-tile', [
                'prefix',
                'position',
                'ppset',
                'type',
            ], 'tile');

            $('#teaser-slider > a').each(function() {
                if ($(this).data('position') && $(this).data('ppset') && $(this).data('type')) {
                    const $name = 'ppset-teaser:' + $(this).data('position') + ':' + $(this).data('ppset') + ':' + $(this).data('type');
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'ppset-teaser:show',
                        $name,
                    ]);
                }
            });

            window.c24Lp.createClickTracking('#teaser-slider > a', [
                'prefix',
                'position',
                'ppset',
                'type',
            ], 'ppset-teaser');

            const fvTileVss = document.querySelector('.fvTileVss');

            if (fvTileVss) {

                $('.fvTileVss').one('click', function() {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'fv:click',
                    ]);
                });

                let fvTileTracked = false;

                const fvTileCallback = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !fvTileTracked) {
                            window._paq.push([
                                'trackEvent',
                                window.c24Lp.getMatomoEventCategory(),
                                'fv:show',
                            ]);
                            fvTileTracked = true;
                        }
                    });
                };

                const fvTileVssObserver = new IntersectionObserver(fvTileCallback, options);

                fvTileVssObserver.observe(fvTileVss);
            }

            $('.c24m-contact-wrapper').one('click', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'wf:click',
                    'wf:::chatty',
                ]);
            });

            let contactWireframLinkTracked = false;
            const contactWireframLinkCallback = (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !contactWireframLinkTracked) {
                        window._paq.push([
                            'trackEvent',
                            window.c24Lp.getMatomoEventCategory(),
                            'wf:show',
                            'wf:::chatty',
                        ]);
                        contactWireframLinkTracked = true;
                    }
                });
            };
            const contactWireframLinkObserver = new IntersectionObserver(contactWireframLinkCallback, options);

            const contactWrapper = document.querySelector('.c24m-contact-wrapper');
            if (contactWrapper) {
                contactWireframLinkObserver.observe(contactWrapper);
            }
        }
    });
})();
